import jsvat from 'jsvat';

export const VAT_RATE_TYPE_WITHOUT_VAT = 'without-vat'; // osvobozeno
export const VAT_RATE_TYPE_BASIC = 'basic'; // základní
export const VAT_RATE_TYPE_REDUCED_1 = 'reduced-1'; // snížená
export const VAT_RATE_TYPE_REDUCED_2 = 'reduced-2'; // 2. snížená

export const PRICE_TYPE_WITHOUT_VAT = 'without-vat';
export const PRICE_TYPE_WITH_VAT = 'with-vat';

export const NON_EU_VAT_COUNTRIES = {
    "CH": "CH",
    "CHE": "CH",
    "AL": "AL",
    "ALK": "AL",
    "ALJ": "AL",
    "AU": "AU",
    "BY": "BY",
    "CA": "CA",
    "IS": "IS",
    "IN": "IN",
    "ID": "ID",
    "IL": "IL",
    "NZ": "NZ",
    "NO": "NO",
    "PH": "PH",
    "RU": "RU",
    "SM": "SM",
    "RS": "RS",
    "TR": "TR",
    "UA": "UA",
    "UZ": "UZ",
    "AR": "AR",
    "BO": "BO",
    "BR": "BR",
    "CL": "CL",
    "CO": "CO",
    "CR": "CR",
    "EC": "EC",
    "SV": "SV",
    "GT": "GT",
    "HN": "HN",
    "MX": "MX",
    "NI": "NI",
    "PA": "PA",
    "PY": "PY",
    "PE": "PE",
    "DO": "DO",
    "UY": "UY",
    "VE": "VE",
};

export function validateVAT(vatId) {
    if (!vatId) {
        return true;
    }

    return jsvat.checkVAT(vatId);
}

// eslint-disable-next-line max-params
export function convertVATtoCode(country : string, vat : number, date: Date, base: number, tax: number, total: number) {
    if (vat !== undefined) {
        try {
            vat = parseFloat(vat);
        } catch (e) {
            /* ignore parsing error */
        }
    }

    /* automatic detection of VAT rate from numbers */
    if (vat === undefined) {
        try {
            if (base !== undefined && tax !== undefined) {
                total = parseFloat(base) + parseFloat(tax);
            } else if (base !== undefined && total !== undefined) {
                tax = parseFloat(total) - parseFloat(base);
            } else if (total !== undefined && tax !== undefined) {
                base = parseFloat(total) - parseFloat(tax);
            }

            if (base !== undefined && total !== undefined) {
                vat = ((parseFloat(total) / parseFloat(base)) - 1.0) * 100.0;
            }
        } catch (e) {
            /* ignore parsing error */
        }
    }

    if (country && country.toUpperCase() === 'SK') {
        if (vat !== undefined) {
            if (vat === 0) {
                return VAT_RATE_TYPE_WITHOUT_VAT;
            } else if (vat > 10) {
                return VAT_RATE_TYPE_BASIC;
            } else {
                return VAT_RATE_TYPE_REDUCED_1;
            }
        } else {
            return VAT_RATE_TYPE_BASIC;
        }
    } else {
        if (vat !== undefined) {
            if (vat === 0) {
                return VAT_RATE_TYPE_WITHOUT_VAT;
            } else if (vat > 15) {
                return VAT_RATE_TYPE_BASIC;
            } else if (vat > 10) {
                return VAT_RATE_TYPE_REDUCED_1;
            } else {
                return VAT_RATE_TYPE_REDUCED_2;
            }
        } else {
            /* if there is vat still not defined */
            return VAT_RATE_TYPE_BASIC;
        }
    }
}
